import * as Sentry from '@sentry/react';

/**
 * Kullanıcı bilgilerini Sentry'ye ekle
 * @param {Object} user - Kullanıcı bilgileri
 */
export const setSentryUser = (user) => {
    if (user) {
        Sentry.setUser({
            id: user.id || user.user_id,
            email: user.email,
            username: user.username || user.name,
        });
    } else {
        Sentry.setUser(null);
    }
};

/**
 * Özel bir breadcrumb ekle
 * @param {string} category
 * @param {string} message
 * @param {string} level
 * @param {Object} data
 */
export const addSentryBreadcrumb = (category, message, level = 'info', data = {}) => {
    Sentry.addBreadcrumb({
        category,
        message,
        level,
        data,
        timestamp: Date.now() / 1000,
    });
};

/**
 * Manuel olarak bir hatayı Sentry'ye gönder
 * @param {Error} error
 * @param {Object} context
 */
export const captureException = (error, context = {}) => {
    Sentry.captureException(error, {
        contexts: {
            custom: context,
        },
    });
};

/**
 * Manuel olarak bir mesajı Sentry'ye gönder
 * @param {string} message
 * @param {string} level
 * @param {Object} context
 */
export const captureMessage = (message, level = 'info', context = {}) => {
    Sentry.captureMessage(message, {
        level,
        contexts: {
            custom: context,
        },
    });
};

/**
 * API hatalarını Sentry'ye gönder
 * @param {Error} error
 * @param {Object} requestInfo
 */
export const captureApiError = (error, requestInfo = {}) => {
    const { url, method, data, response } = requestInfo;

    Sentry.captureException(error, {
        tags: {
            type: 'api_error',
            method: method || 'unknown',
        },
        contexts: {
            api: {
                url,
                method,
                requestData: data,
                responseStatus: response?.status,
                responseData: response?.data,
            },
        },
    });
};


/**
 * Özel bir tag ekle
 * @param {string} key
 * @param {string} value
 */
export const setTag = (key, value) => {
    Sentry.setTag(key, value);
};

/**
 * Özel bir context ekle
 * @param {string} name
 * @param {Object} context
 */
export const setContext = (name, context) => {
    Sentry.setContext(name, context);
};

/**
 * Axios interceptor için hata yakalayıcı
 * @param {Error} error
 */
export const handleAxiosError = (error) => {
    if (error.response) {
        captureApiError(error, {
            url: error.config?.url,
            method: error.config?.method,
            data: error.config?.data,
            response: {
                status: error.response.status,
                data: error.response.data,
            },
        });
    } else if (error.request) {
        captureApiError(error, {
            url: error.config?.url,
            method: error.config?.method,
            data: error.config?.data,
        });
    } else {
        captureException(error, {
            type: 'request_setup_error',
            url: error.config?.url,
        });
    }
};

export default {
    setSentryUser,
    addSentryBreadcrumb,
    captureException,
    captureMessage,
    captureApiError,
    setTag,
    setContext,
    handleAxiosError,
};
